"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _operationsConfig = require("@/api/community/operationsConfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JudgeSettings',
  data: function data() {
    return {
      levelOptions: [{
        label: 'LV1 会员',
        value: 'lv1'
      }, {
        label: 'LV2 会员',
        value: 'lv2'
      }, {
        label: 'LV3 会员',
        value: 'lv3'
      }, {
        label: 'LV4 会员',
        value: 'lv4'
      }, {
        label: 'LV5 会员',
        value: 'lv5'
      }],
      form: {
        qualification: {
          consumeAmount: 100,
          minLevel: 'lv1'
        },
        notices: {
          selectJudge: '恭喜您成为评审官了～',
          wallSuccess: '恭喜您的帖子成功上墙了～',
          cancelJudge: '很遗憾您被取消评审官了～',
          rejectApply: '很遗憾您的帖子被驳回了～',
          illegalVote: '尊敬的评审官，注意你的投票～'
        },
        visual: {
          judgeIcon: [],
          successImage: []
        },
        rules: {
          text: '',
          randomVoters: 0,
          agreeToWall: 0,
          voteHours: 24,
          applyCooldownHours: 0,
          wallHours: 0
        }
      },
      dialogVisible: false,
      dialogImageUrl: '',
      visualPaths: {
        judgeIcon: '',
        successImage: ''
      } // 图片相对路径
    };
  },
  created: function created() {
    this.loadConfig();
  },
  methods: {
    loadConfig: function loadConfig() {
      var _this = this;
      (0, _operationsConfig.getConfigById)(1017).then(function (res) {
        if (res.data && res.data.value) {
          try {
            var config = JSON.parse(res.data.value);
            if (config.qualification) _this.form.qualification = config.qualification;
            if (config.notices) _this.form.notices = config.notices;
            if (config.visual) {
              // 处理图片路径 - 用相对路径展示完整URL
              if (config.visual.judgeIcon && config.visual.judgeIcon.length && config.visual.judgeIcon[0].path) {
                _this.visualPaths.judgeIcon = config.visual.judgeIcon[0].path;
                _this.form.visual.judgeIcon = [{
                  url: (0, _operationsConfig.getImageUrl)(config.visual.judgeIcon[0].path),
                  name: 'judge-icon.jpg'
                }];
              }
              if (config.visual.successImage && config.visual.successImage.length && config.visual.successImage[0].path) {
                _this.visualPaths.successImage = config.visual.successImage[0].path;
                _this.form.visual.successImage = [{
                  url: (0, _operationsConfig.getImageUrl)(config.visual.successImage[0].path),
                  name: 'success-image.jpg'
                }];
              }
            }
            if (config.rules) _this.form.rules = config.rules;
          } catch (e) {/* 忽略 */}
        }
      });
    },
    onExceed: function onExceed() {
      this.$message.warning('仅可上传一张图片');
    },
    handlePreview: function handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onFileChange: function onFileChange(key, fileList) {
      var _this2 = this;
      var last = fileList[fileList.length - 1];
      if (last && last.raw) {
        (0, _operationsConfig.uploadImage)(last.raw, '/').then(function (res) {
          _this2.visualPaths[key] = res.data;
          last.url = (0, _operationsConfig.getImageUrl)(res.data);
          _this2.form.visual[key] = [last];
        });
      }
    },
    onReset: function onReset() {
      this.$refs.opsForm.resetFields();
      this.form.visual.judgeIcon = [];
      this.form.visual.successImage = [];
      this.visualPaths = {
        judgeIcon: '',
        successImage: ''
      };
    },
    onSubmit: function onSubmit() {
      var _this3 = this;
      var payload = {
        qualification: this.form.qualification,
        notices: this.form.notices,
        visual: {
          judgeIcon: this.visualPaths.judgeIcon ? [{
            path: this.visualPaths.judgeIcon
          }] : [],
          successImage: this.visualPaths.successImage ? [{
            path: this.visualPaths.successImage
          }] : []
        },
        rules: this.form.rules
      };
      (0, _operationsConfig.updateConfig)(1017, JSON.stringify(payload)).then(function () {
        _this3.$message.success('已保存评审官设置');
        _this3.loadConfig();
      });
    }
  }
};